// v2 Material re-skin: the existing Angular Material M2 theme reads these CSS custom
// properties at runtime (see src/styles/linxio-theme.scss). Applied INLINE on <html> by
// ClientV2Component while the v2 shell is mounted, so they win the cascade unambiguously
// and Material widgets used inside v2 render in the blue "Infinity" palette.
// Removed on destroy → v1 (/client/*) is completely unaffected.
export const V2_MATERIAL_VARS: Record<string, string> = {
  '--accent-color': '#1665d8',
  '--menu-background-color': '#252529',
  '--primary-background-color': '#ffffff',
  '--secondary-background-color': '#f5f5f5',
  '--primary-border-color': '#e0e0e0',
  '--primary-font-color': '#212121',
  '--secondary-font-color': '#6b6c6f',
  '--main-green-color': '#34aa44',
  '--orange-500-color': '#f6ab2f',
  '--red-500-color': '#e6492d',
  '--main-gray-color': '#9ea0a5',
  // blue-shift the Material primary ramp so non-500 shades (checkbox, hover, darker/lighter) aren't purple:
  '--primary-50-color': '#e8f0fb',
  '--primary-100-color': '#c7dcf7',
  '--primary-200-color': '#9dc1f0',
  '--primary-300-color': '#6fa3e8',
  '--primary-400-color': '#3d82df',
  '--primary-500-color': '#1665d8',
  '--primary-600-color': '#1459c2',
  '--main-primary-bg-color': '#1254b8',
  '--primary-800-color': '#0f449a',
  '--primary-900-color': '#0b3374',
}
